import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Observable } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { Pais } from '../shared/model';
import {MunicipioVO} from '../shared/model/municipio-vo.model';
import { Municipio } from './../shared/model/municipio.model';

@Injectable({
  providedIn: 'root'
})
export class EnderecoService {

  private readonly endpointPais = '/sepin-backend/rest/proxy/endereco/pais';
  private readonly endpointMunicipio = '/sepin-backend/rest/proxy/endereco';

  private _paisObservable: Observable<Pais[]>;
  private _acordoInternacional: Pais = new Pais();

  constructor(private readonly http: McticHttpClient) {
  }

  obterPaises(): Observable<Pais[]> {
    this._paisObservable = this.http.get<Pais[]>(this.endpointPais).pipe(
      map(paises => this.formatarListaPaises(paises)),
      publishReplay(1),
      refCount()
    );

    return this._paisObservable;
  }

  private formatarListaPaises(paises: any[]) {
    paises.forEach(pais => {
      if (pais.nome.indexOf(',') > -1) {
        pais.nome = `${pais.nome.split(',')[1].trim()} ${pais.nome.split(',')[0].trim()}`;
      }
      pais.nome = this.toTitleCase(pais.nome);
    });
    paises = paises.filter(pais => pais.nome.length > 0 && pais.ddi !== 9999);
    paises = paises.sort((p1, p2) => p1.nome.localeCompare(p2.nome));
    paises.splice(0, 0, paises.filter(pais => pais.ddi === 55)[0]);
    return paises;
  }

  private toTitleCase(texto: string) {
    const textoResultante = texto.toLowerCase().split(' ');
    for (let i = 0; i < textoResultante.length; i++) {
      textoResultante[i] = textoResultante[i].charAt(0).toUpperCase() + textoResultante[i].slice(1);
    }
    return textoResultante.join(' ');
  }

  public get acordoInternacional(): Pais {
      this._acordoInternacional.id = 999;
      this._acordoInternacional.nome = 'Acordo internacional'
      return this._acordoInternacional;
  }

  obterMunicipio(codigoMunicipio: string): Observable<Municipio> {
    return this.http.get<Municipio>(`${this.endpointMunicipio}/municipio/ibge/${codigoMunicipio}`);
  }

  obterMunicipioPorId(idMunicipio: string): Observable<Municipio> {
    return this.http.get<Municipio>(`${this.endpointMunicipio}/municipio/${idMunicipio}`);
  }

}
